export enum DateFilterType {
  diario,
  semanal,
  mensal,
  periodo,
}

export function DateFilterTypeToString(type: DateFilterType) {
  return ["diario", "semanal", "mensal", "periodo"][type];
}

export interface Tenant {
  value: string;
  name: string;
}

export interface FiltroDataModel {
  dateFilterType?: DateFilterType;
  dateFilter?: Date;
  dateFilterEnd?: Date;
  comparableDateFilter?: Date;
  comparableDateFilterEnd?: Date;
}

export interface AppModel {
  filtroModel?: FiltroDataModel;
  tenants?: Tenant[];
}
